// Alternate public gateways resolve the same content-addressed image.
export function logoSources(source: string | null): string[] {
  if (!source) return [];
  try {
    const url = new URL(source);
    const match = url.pathname.match(
      /^\/ipfs\/((?:Qm[1-9A-HJ-NP-Za-km-z]{44}|b[a-z2-7]{20,}))(\/.*)?$/,
    );
    if (!match) return [source];
    const path = match[1] + (match[2] || '');
    return [
      ...new Set([
        source,
        'https://ipfs.filebase.io/ipfs/' + path,
        'https://ipfs.io/ipfs/' + path,
      ]),
    ];
  } catch {
    return [];
  }
}
